export const blockIconsPrivacyandsecurityVerifiedUserNew = (
	<span className='material-symbols-outlined'>verified_user</span>
);
